import React from "react";
import {
  medicalData,
  whyChooseUs,
} from "../../componentsUpdated/constants/Common";
import MedicalCard from "../MedicalCard";

const ChooseCard = ({ imgUrl, text }) => {
  return (
    <div className="flex flex-col items-center">
      <div>
        <img src={imgUrl} alt="card" />
      </div>
      <div className=" pt-3 md:pt-4 font-normal text-lg md:text-2xl leading-4.5 text-center md:leading-6 font-halyard tracking-normal ">
        {text}
      </div>
    </div>
  );
};

const WhyChooseUs = () => {
  return (
    <div>
      <div className="!pt-14 md:!pt-48">
        <div className="text-6.5 md:text-14 font-medium text-primaryText text-center font-halyard md:leading-14">
          Why Choose Us
        </div>
        <div className="bg-lightGray !px-4 md:!px-10">
          <div className="max-w-custom mx-auto">
            <div className="grid gap-x-10 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 mt-16">
              {whyChooseUs?.map((ele, idx) => (
                <ChooseCard key={idx} {...ele} />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div
        className="!pt-13.5 md:!pt-28 bg-lightGray !px-4 md:!px-10"
        id="services"
      >
        <div className="max-w-custom mx-auto">
          <div className="text-[26px] md:text-14 font-medium text-primaryText text-center leading-5 font-halyard">
            Services
          </div>
          <div className="grid gap-x-10 gap-y-4 sm:grid-cols-2 lg:grid-cols-4 !mt-5 md:!mt-16">
            {medicalData?.map((ele, idx) => (
              <MedicalCard key={idx} {...ele} />
            ))}
          </div>
          <div className="flex justify-center items-center pt-5 pb-13.5 md:!pt-16 md:!pb-30"></div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
